import { render, staticRenderFns } from "./MediaPages.vue?vue&type=template&id=10980937&"
import script from "./MediaPages.vue?vue&type=script&lang=js&"
export * from "./MediaPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports